// EmptyState — replaces CRUD "No records found". Guides action with explanation + CTA.

import { ElementType, ReactNode } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  actionIcon: ActionIcon
}: {
  icon?: ElementType<{ size?: number }>;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: ElementType<{ size?: number }>;
  children?: ReactNode;
}) {
  return (
    <Stack alignItems="center" spacing={1.5} sx={{ py: 6, textAlign: 'center' }}>
      {Icon ? (
        <Box sx={{ color: 'text.disabled' }}>
          <Icon size={48} />
        </Box>
      ) : null}
      <Typography variant="h6" color="text.primary" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
      {description ? (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 380 }}>
          {description}
        </Typography>
      ) : null}
      {actionLabel && onAction ? (
        <Button variant="outlined" startIcon={ActionIcon ? <ActionIcon size={18} /> : undefined} onClick={onAction} sx={{ mt: 1 }}>
          {actionLabel}
        </Button>
      ) : null}
    </Stack>
  );
}
